import { render, staticRenderFns } from "./LoadingDialog.vue?vue&type=template&id=bef7eff6&"
import script from "./LoadingDialog.vue?vue&type=script&lang=ts&"
export * from "./LoadingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingDialog.vue?vue&type=style&index=0&id=bef7eff6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports